export default "__VITE_ASSET__wBc1qJWI__"